import { createAsyncThunk } from '@reduxjs/toolkit';
import { LogParams } from '../Domain/Repositories/LogRepository';
import { LogRepositoryImpl } from '../Data/Repositories/LogRepositoryImpl';
import { GetLogsUseCase } from '../Domain/UseCase/GetLogsUseCase';
import { DeleteLogUseCase } from '../Domain/UseCase/DeleteLogUseCase';

const repo = new LogRepositoryImpl();

export const fetchLogs = createAsyncThunk('log/fetchAll', (params?: LogParams) =>
  new GetLogsUseCase(repo).execute(params),
);

// 오늘 로그 조회
export const fetchTodayLogs = createAsyncThunk('log/fetchToday', () =>
  new GetLogsUseCase(repo).execute({ filter_type: 'today' }),
);

// 어제 로그 조회
export const fetchYesterdayLogs = createAsyncThunk('log/fetchYesterday', () =>
  new GetLogsUseCase(repo).execute({ filter_type: 'yesterday' }),
);

// 이번달 로그 조회
export const fetchThisMonthLogs = createAsyncThunk('log/fetchThisMonth', () =>
  new GetLogsUseCase(repo).execute({ filter_type: 'this_month' }),
);

// 기간별 로그 조회
export const fetchCustomRangeLogs = createAsyncThunk(
  'log/fetchCustomRange', 
  (params: { start_date: string; end_date: string }) =>
    new GetLogsUseCase(repo).execute({ 
      filter_type: 'custom', 
      start_date: params.start_date, 
      end_date: params.end_date 
    }),
);

// 로그 삭제
export const deleteLog = createAsyncThunk(
  'log/delete',
  (logId: number) => new DeleteLogUseCase(repo).execute(logId)
);


// 로그 일괄 삭제 (ADMIN 전용)
export const bulkDeleteLogs = createAsyncThunk(
  'log/bulkDelete',
  (logIds: number[]) => new DeleteLogUseCase(repo).executeBulk(logIds)
);
